import _ from 'underscore';

export const Filterable = (superclass) => class extends superclass {
  actsAsFilterable(filteringEnabled) {
    if (!filteringEnabled) {
      return;
    }

    this._filterCallbacks = {
      before: [],
      after: []
    };

    this.afterFilter(this._updateBtnClearFilterState.bind(this));
  }

  filter(filters) {
    this._runFilterCallbacks('before');

    this.list.filter(
      function (item) {
        return this._filterItem(item, filters);
      }.bind(this)
    );

    this._runFilterCallbacks('after');
  }

  beforeFilter(callback) {
    this._filterCallbacks.before.push(callback);
  }

  afterFilter(callback) {
    this._filterCallbacks.after.push(callback);
  }

  _updateBtnClearFilterState() {
    let filters = this.menu.filters;
    let m = Object.keys(filters).map(
      function (k) {
        return this._hasFilters(filters[k]);
      }.bind(this)
    );

    if (m.indexOf(true) !== -1) {
      this.menu.$btnClearFilters.show();
    } else {
      this.menu.$btnClearFilters.hide();
    }
  }

  // returns false if a filter has something set on it
  _hasFilters(filter) {
    if (filter instanceof Array) {
      return filter.length > 0;
    } else {
      return !!filter;
    }
  }

  _runFilterCallbacks(kind) {
    let data = {
      itemsCount: this.list.matchingItems.length
    };
    _.each(this._filterCallbacks[kind], function (callback) {
      callback(data);
    });
  }

  _filterItem(item, filters) {
    let matchesPrice = this._filterItemByPrice(item, filters['prices']);
    let matchesFormat = this._filterItemByFormat(item, filters['formats']);
    let matchesPersonalized = this._filterItemByPersonalized(item, filters['personalized']);

    return matchesPrice && matchesFormat && matchesPersonalized;
  }

  _filterItemByPrice(item, priceFilters) {
    let lowPrice;
    let highPrice;
    let price;
    let include;

    include = false;
    price = parseInt(item.values().price, 10);

    if (priceFilters && priceFilters.length) {
      _.each(priceFilters, function (priceRange) {
        lowPrice = parseInt(priceRange[0], 10);
        highPrice = parseInt(priceRange[1], 10);

        if (price >= lowPrice && price <= highPrice) {
          include = true;
        }
      });
    } else {
      include = true;
    }

    return include;
  }

  _filterItemByFormat(item, formatFilters) {
    if (formatFilters && formatFilters.length) {
      return _.indexOf(formatFilters, item.values().format) !== -1;
    } else {
      return true;
    }
  }

  _filterItemByPersonalized(item, personalizedFilter) {
    if (personalizedFilter) {
      return item.values().personalized === personalizedFilter;
    } else {
      return true;
    }
  }
};
